// Sign-in (mockup 3). Email link first, password as the fallback. Company brand mark is the tenant's.
import { useState, type FormEvent } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { ENV } from '../env';

export function SignIn({ error }: { error: string | null }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(error);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setMsg(null);
    try { await signInWithEmailAndPassword(auth, email.trim(), password); }
    catch (err) { setMsg(friendly(err)); }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-full flex flex-col">
      <form onSubmit={submit} className="flex-1 flex flex-col justify-center gap-3.5 px-5 max-w-[420px] w-full mx-auto">
        <div className="flex flex-col items-center gap-2.5 mb-2">
          <div className="w-16 h-16 rounded-[18px] bg-accent text-accent-ink grid place-items-center font-disp font-bold text-4xl">T</div>
          <h1 className="font-disp font-bold text-[38px] leading-none m-0">TradeView</h1>
          <p className="m-0 text-muted text-sm">{ENV.name === 'production' ? 'trade-view.app' : `${ENV.name} · ${ENV.firebase.projectId}`}</p>
        </div>
        <label className="flex flex-col gap-1.5">
          <span className="font-head font-semibold text-[13px]">Work email</span>
          <input id="email" className="field-in" type="email" autoComplete="username" inputMode="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="font-head font-semibold text-[13px]">Password</span>
          <input id="password" className="field-in" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required />
        </label>
        {msg && <div className="rounded-[12px] bg-crit-soft text-crit px-3 py-2.5 text-[13.5px]"><b className="font-head block">Couldn't sign in</b><span className="text-fg">{msg}</span></div>}
        <button className="btn btn-primary btn-block" type="submit" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
        <p className="m-0 text-center text-[13px] text-muted">New here? Your office sends an invite link by text or email. Open it on this phone and it brings you here, set up.</p>
      </form>
      <p className="text-center text-muted text-xs pb-7">Works offline once you've signed in on this phone.</p>
    </div>
  );
}

function friendly(err: unknown): string {
  const code = (err as { code?: string })?.code ?? '';
  if (code.includes('invalid-credential') || code.includes('wrong-password') || code.includes('user-not-found')) return 'That email and password don\'t match. Try again, or ask the office to reset it.';
  if (code.includes('too-many-requests')) return 'Too many tries. Wait a minute and try again.';
  if (code.includes('network')) return 'No connection. Try again when you have signal.';
  return err instanceof Error ? err.message : 'Something went wrong.';
}
